// eslint-disable-next-line
const sleep = (ms: number = 100) => new Promise((resolve) => setTimeout(resolve, ms));

export default sleep;
